import { Box, Paper, styled } from "@mui/material";

export const RoutedTabsContainer = styled(Paper)`
  box-shadow: 0px 1px 2px 1px rgba(0, 0, 0, 0.05);
`;

export const RoutedTabContent = styled(Box)`
  border-top: 1px solid ${({ theme }) => theme.palette.divider};
  padding: ${({ theme }) => theme.spacing(4)};
`;
